import { millisecondsToSeconds, secondsToMilliseconds } from 'date-fns';

export const sleep = async (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Generates a nonce in nanoseconds.
 *
 * Uses Date.now() directly to avoid clock drift issues that occur when
 * performance.timeOrigin becomes stale in long-running browser tabs (https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6).
 */
export const getNonceInNanoseconds = () => {
  const bufferInMilliseconds = secondsToMilliseconds(10);
  const ts = Date.now() - bufferInMilliseconds;
  const num = Math.round(ts * 1000000);
  return BigInt(num);
};

// TODO, backend should add a few second buffer, but some users are running into error where the time is in the future. So add it here for now.
export const nowInSeconds = () => millisecondsToSeconds(Date.now()) - 10;
